import React, { useEffect, useState, useRef, useCallback } from "react";
import { useAuth } from "../../components/context/AuthContext";



// Traduction des couleurs pour le canvas
const couleurEnAnglais = {
    "rouge": "red",
    "bleu": "blue",
    "vert": "green",
    "jaune": "yellow",
    "noir": "black",
    "violet": "purple"
};

function traduireCouleur(couleur) {
    return couleurEnAnglais[couleur.toLowerCase()] || "black";
}

function CreerMur() {
    const { user } = useAuth();
    const [nomMur, setNomMur] = useState("");
    const [formes, setFormes] = useState([]);
    const [formesAjoutees, setFormesAjoutees] = useState([]);
    const murCanvasRef = useRef(null);
    const formesCanvasRef = useRef(null);
    const [selectedForme, setSelectedForme] = useState(null);
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const grilleSize = 50;
    const [infoForme, setInfoForme] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ADMIN_URL}/formes`)
            .then((res) => res.json())
            .then((data) => {
                const formesAvecPosition = data.map((f, index) => ({
                    ...f,
                    posX: 50,
                    posY: 50 + index * 50,
                }));
                setFormes(formesAvecPosition);
            })
            .catch((err) => console.error("Erreur API : ", err));
    }, []);

    const ajouterFormeAuMur = (forme) => {
        const newForme = {
            ...forme,
            posX: 100,
            posY: 100,
            uniqueId: `${forme.id}-${Date.now()}`
        };
        setFormesAjoutees([...formesAjoutees, newForme]);
    };

    const dessinerGrille = useCallback((ctx, width, height) => {
        ctx.strokeStyle = "#ccc"; // Couleur de la grille
        ctx.lineWidth = 0.5;

        for (let x = 0; x <= width; x += grilleSize) {
            ctx.beginPath();
            ctx.moveTo(x, 0);
            ctx.lineTo(x, height);
            ctx.stroke();
        }

        for (let y = 0; y <= height; y += grilleSize) {
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.lineTo(width, y);
            ctx.stroke();
        }
    }, [grilleSize]);

    const dessinerFormes = useCallback((canvasRef, listeFormes) => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        dessinerGrille(ctx, canvas.width, canvas.height);

        listeFormes.forEach((forme) => {
            const couleur = traduireCouleur(forme.couleur);
            const estSelectionnee = selectedForme && forme === selectedForme;
            ctx.fillStyle = couleur;
            ctx.save();
            ctx.translate(forme.posX, forme.posY);

            if (estSelectionnee) {
                ctx.strokeStyle = "black";
                ctx.lineWidth = 3;
            }

            if (forme.nom.toLowerCase().includes("rectangle")) {
                ctx.fillRect(-forme.largeur / 2, -forme.longueur / 2, forme.largeur, forme.longueur);
                if (estSelectionnee) {
                    ctx.strokeRect(-forme.largeur / 2, -forme.longueur / 2, forme.largeur, forme.longueur);
                }
            } else if (forme.nom.toLowerCase().includes("rond")) {
                ctx.beginPath();
                ctx.arc(0, 0, forme.rayon, 0, Math.PI * 2);
                ctx.fill();
                if (estSelectionnee) {
                    ctx.stroke();
                }
            } else if (forme.nom.toLowerCase().includes("triangle")) {
                const { base, hauteur } = forme;
                ctx.beginPath();
                ctx.moveTo(-base / 2, hauteur / 2); // Bas gauche
                ctx.lineTo(base / 2, hauteur / 2);  // Bas droit
                ctx.lineTo(-base / 2, -hauteur / 2); // Sommet pour triangle rectangle
                ctx.closePath();
                ctx.fill();
                if (estSelectionnee) ctx.stroke();
            } else if (forme.nom.toLowerCase().includes("hexagone")) {
                ctx.beginPath();
                for (let i = 0; i < 6; i++) {
                    const angle = (Math.PI / 3) * i;
                    const x = Math.cos(angle) * forme.cotes;
                    const y = Math.sin(angle) * forme.cotes;
                    if (i === 0) ctx.moveTo(x, y);
                    else ctx.lineTo(x, y);
                }
                ctx.closePath();
                ctx.fill();
                if (estSelectionnee) ctx.stroke();
            }
           // console.log(selectedForme.uniqueId);
            
            ctx.restore();
        });
    }, [dessinerGrille, selectedForme]);

    useEffect(() => {
        dessinerFormes(murCanvasRef, formesAjoutees);
    }, [dessinerFormes, formesAjoutees,selectedForme]);

    useEffect(() => {
        dessinerFormes(formesCanvasRef, formes);
    }, [dessinerFormes, formes]);

    const handleMouseDown = (event) => {
        const rect = murCanvasRef.current.getBoundingClientRect();
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;

        const clickedForme = formesAjoutees.find((forme) => {
            const nomForme = forme.nom.split(" ")[0];
            if (nomForme.toLowerCase().includes("rectangle")) {
                return (
                    mouseX >= forme.posX - forme.largeur / 2 &&
                    mouseX <= forme.posX + forme.largeur / 2 &&
                    mouseY >= forme.posY - forme.longueur / 2 &&
                    mouseY <= forme.posY + forme.longueur / 2
                );
            } else if (nomForme.toLowerCase().includes("rond")) {
                const distance = Math.sqrt((mouseX - forme.posX) ** 2 + (mouseY - forme.posY) ** 2);
                return distance <= forme.rayon;
            } else if (nomForme.toLowerCase().includes("triangle")) {
                const hauteurAbs = Math.abs(forme.hauteur);
                const baseAbs = Math.abs(forme.base);
                return (
                    mouseX >= forme.posX - baseAbs / 2 &&
                    mouseX <= forme.posX + baseAbs / 2 &&
                    mouseY >= forme.posY - hauteurAbs / 2 &&
                    mouseY <= forme.posY + hauteurAbs / 2
                );
            } else if (nomForme.toLowerCase().includes("hexagone")) {
                const distance = Math.sqrt((mouseX - forme.posX) ** 2 + (mouseY - forme.posY) ** 2);
                return distance <= forme.cotes * 1.5;
            }
            return false;
        });
        
        if (clickedForme) {
            setSelectedForme(clickedForme);
            setOffset({ x: mouseX - clickedForme.posX, y: mouseY - clickedForme.posY });
            setInfoForme({
                nom: clickedForme.nom,
                posX: clickedForme.posX,
                posY: clickedForme.posY,
            });
        } else {
            // Si aucun forme n'est cliquée : désélectionner
            setSelectedForme(null);
            setInfoForme(null);
        }
    };
    const handleMouseMove = (event) => {
        if (!selectedForme) return;
        const rect = murCanvasRef.current.getBoundingClientRect();
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;
        setFormesAjoutees((formes) =>
            formes.map((forme) =>
                forme.uniqueId === selectedForme.uniqueId
                    ? { ...forme, posX: mouseX - offset.x, posY: mouseY - offset.y}
                    : forme
            )
        );
        // Met à jour dynamiquement les coordonnées de la forme affichée
        setInfoForme((prev) => prev ? { ...prev, posX: mouseX - offset.x, posY: mouseY - offset.y } : null);
    };
    const handleMouseUp = () => {
        setSelectedForme(null);
    };
    const enregistrerMur = async () => {
        if (!nomMur.trim()) {
            alert("Veuillez entrer un nom pour le mur.");
            return;
        }
        const mur = {
            nom: nomMur,
            userId: user?.id,
            briques: formesAjoutees.map((forme) => {
                let posX = forme.posX;
                let posY = forme.posY;
                let largeur = forme.largeur;
                let longueur = forme.longueur;
                let base = forme.base;
                let hauteur = forme.hauteur;
                if (forme.nom.toLowerCase() === "rectangle h" || forme.nom.toLowerCase () === "rectangle v") {
                    posX -= largeur / 2;
                   posY -= longueur /2;
                }
                if (forme.nom.toLowerCase() ==="triangle bas" 
                    || forme.nom.toLowerCase() ==="triangle haut" 
                    || forme.nom.toLowerCase() === "triangle droite" 
                    || forme.nom.toLowerCase() === "triangle gauche") {
                    posX -= base / 2;
                    posY += hauteur /2;
                } 
                return {
                    type: forme.nom.split(" ")[0],
                    id: forme.id,
                    nom: forme.nom,
                    posX: posX,
                    posY: posY,
                    couleur: forme.couleur,
                    ...(base !== undefined && { base }),
                    ...(hauteur !== undefined && { hauteur }),
                    ...(forme.rayon !== undefined && { rayon: forme.rayon }),
                    ...(forme.cotes !== undefined && { cotes: forme.cotes }),
                    ...(largeur !== undefined && { largeur: largeur }),
                    ...(longueur !== undefined && { longueur: longueur }),
                };
            }),
        };
        try {
            const isAdmin = user?.role === 'ADMIN';
            console.log(isAdmin);
            const url = isAdmin
                ? `${process.env.REACT_APP_API_ADMIN_URL}/MurDeBrique/ajouter`
                : `${process.env.REACT_APP_API_USER_URL}/murs`; // ou /users/:id/murs selon ton routing
                console.log("Payload du mur :", JSON.stringify(mur, null, 2));
            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(
                    isAdmin ? mur : { ...mur, utilisateurId: user?.id }
                )
            });
    
            if (!response.ok) throw new Error("Erreur lors de la création du mur");
            alert(`Mur "${nomMur}" enregistré avec succès !`);
            setNomMur("");
            setFormesAjoutees([]);
        } catch (error) {
            console.error("Erreur :", error);
            alert("Une erreur est survenue lors de l'enregistrement du mur.");
        }
    };
    return (
        <div className="mur-wrapper">
            <h2>&#x1F9F1; Créer un Mur</h2>
            <div className="triple-canvas-container">
                {infoForme && (
                    <div style={{
                        position: "absolute",
                        top: "10px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        padding: "10px",
                        background: "rgba(0,0,0,0.8)",
                        color: "white",
                        borderRadius: "8px",
                        fontSize: "16px",
                        zIndex: 999
                    }}>
                        <strong>Forme sélectionnée :</strong> {infoForme.nom} <br />
                        <strong>X :</strong> {infoForme.posX.toFixed(2)} px | <strong>Y :</strong> {infoForme.posY.toFixed(2)} px
                    </div>
                )}
    
                <div className="canvas-panel">
                    <canvas
                        ref={murCanvasRef}
                        width={1000}
                        height={500}
                        onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                    />
                </div>
    
                <div className="formes-panel">
                    <canvas
                        ref={formesCanvasRef}
                        width={100}
                        height={500}
                    />
                </div>
    
                <div className="boutons-formes">
                    {formes.map((forme) => (
                        <button key={forme.id} onClick={() => ajouterFormeAuMur(forme)}>
                            &#10133; Ajouter {forme.nom}
                        </button>
                    ))}
    
                    <label style={{ fontSize: "14px", color: "#fff", marginTop: "10px" }}>
                    &#x1F3F7;&#xFE0F; Nom du mur :
                    </label>
                    <input
                        type="text"
                        value={nomMur}
                        onChange={(e) => setNomMur(e.target.value)}
                        placeholder="Entrez un nom..."
                        style={{
                            padding: "8px",
                            fontSize: "14px",
                            marginTop: "5px",
                            borderRadius: "5px",
                            border: "1px solid #ccc"
                        }}
                    />
                    <button onClick={enregistrerMur}>
                    &#x1F4BE; Enregistrer le mur
                    </button>
                </div>
            </div>
        </div>
    );
}
export default CreerMur;
